module.exports = __webpack_public_path__ + "static/media/find-app.f7d94c09.jpeg";